import React from 'react';
import { CircularProgress, Divider } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { classes, style } from 'typestyle';

import { ADALONG_COLORS } from '@src/styles';

interface CategorySectionProps {
  name: string;
  isCollapsed: boolean;
  itemCount: number;
  isLoading: boolean;
  onToggle: (name: string) => void;
  children?: React.ReactNode;
}

export function CategorySection({
  name,
  isCollapsed,
  itemCount,
  isLoading,
  onToggle,
  children,
}: CategorySectionProps) {
  return (
    <div className={categorySectionClass}>
      <button
        type='button'
        className={categoryHeaderButtonClass}
        onClick={() => onToggle(name)}
        aria-expanded={!isCollapsed}
      >
        <span className={categoryTitleClass}>{name}</span>
        <span className={categoryMetaClass}>
          <span className={categoryCountClass}>
            {isLoading ? (
              <span className={categoryCountLoaderClass}>
                <CircularProgress size={14} thickness={5} />
              </span>
            ) : (
              `${itemCount} items`
            )}
          </span>
          <KeyboardArrowDownIcon
            className={classes(categoryChevronClass, isCollapsed && categoryChevronCollapsedClass)}
            fontSize='medium'
            style={{ fontSize: 26 }}
          />
        </span>
      </button>
      <Divider className={categoryDividerClass} />
      <div className={categoryContentClass} aria-hidden={isCollapsed}>
        {!isCollapsed ? children : null}
      </div>
    </div>
  );
}

const categorySectionClass = style({
  marginBottom: 10,
});

const categoryHeaderButtonClass = style({
  width: '100%',
  border: 'none',
  background: 'transparent',
  color: '#fff',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: 12,
  padding: '14px 0 6px',
  cursor: 'pointer',
  textAlign: 'left',
});

const categoryTitleClass = style({
  fontSize: 16,
  fontWeight: 600,
  flex: 1,
  marginRight: 12,
});

const categoryMetaClass = style({
  display: 'flex',
  alignItems: 'center',
  gap: 4,
});

const categoryCountClass = style({
  fontSize: 13,
  color: ADALONG_COLORS.DARK_GRAY,
  display: 'inline-flex',
  alignItems: 'center',
  gap: 6,
});

const categoryCountLoaderClass = style({
  display: 'inline-flex',
  alignItems: 'center',
  $nest: {
    svg: {
      color: ADALONG_COLORS.DARK_GRAY,
    },
  },
});

const categoryChevronClass = style({
  transition: 'transform 0.2s ease',
  color: '#fff',
  display: 'inline-flex',
});

const categoryChevronCollapsedClass = style({
  transform: 'rotate(-90deg)',
});

const categoryDividerClass = style({
  backgroundColor: ADALONG_COLORS.DARK_GRAY,
});

const categoryContentClass = style({
  padding: '0 4px',
  marginTop: 12,
});

export default CategorySection;
